module.exports = __webpack_public_path__ + "static/media/chrome.17f0de2b.png";